import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@/utils';

export const ContentHeader = ({ className, ...props }: ComponentProps<'div'>) => {
  return <div className={cn('content-header flex flex-row flex-wrap gap-2 lg:flex-nowrap justify-between items-center mb-4 [&_.content-title]:!mb-0', /* '[&_h2]:!border-none border-b', */ className)} {...props} />;
};

export const ContentHeaderButtons = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('flex items-center gap-x-2', className)} {...props} />
);

export const ContentTitle = ({ className, ...props }: ComponentProps<'h2'>) => {
  return <h2 className={cn('content-title mb-4 text-2xl font-bold uppercase italic text-blue-600', className)} {...props} />;
};

export const ContentSubtitle = ({ className, ...props }: ComponentProps<'h3'>) => {
  return <h3 className={cn('content-title text-xl font-bold uppercase italic leading-none tracking-tight text-blue-600 mb-4', className)} {...props} />;
};

interface ContentHeaderWithControlsProps extends Omit<ComponentProps<'div'>, 'title'> {
  title: ReactNode;
  isMainTitle?: boolean;
}

export const ContentHeaderWithControls = ({ isMainTitle = false, children, title, ...props }: ContentHeaderWithControlsProps) => {
  const Title = isMainTitle ? ContentTitle : ContentSubtitle;
  return (
    <ContentHeader {...props}>
      <Title className="leading-9">{title}</Title>

      {children && (
        <ContentHeaderButtons>
          {children}
        </ContentHeaderButtons>
      )}
    </ContentHeader>
  );
};
